<pwa-account-back [coins]="!!mission?.points ? mission?.points : undefined"
                  [rosettes]="!!mission?.rosettes ? mission?.rosettes : undefined"
                  [pointsText]="'Earn %'"
                  [link]="'account/my-missions'" />

@if (content && mission) {
<div class="m-t-10 p-t-3">
    <h2 class="h3 center"
        *iCms="'title' of content"></h2>
    <h3 class="s1 m-t-5 center">{{ mission.title | translate }}</h3>

    <div class="m-t-8 bg-col-w p-a p-t-5 p-b-5">
        <div class="p2 col-11"
             [innerHTML]="mission.description | translate"></div>

        <!-- Dynamic progress bars based on tags -->
        @if (getDynamicProgressData(); as progressData) {
        <div class="m-t-6">
            <div class="flex flex-justify-between flex-bottom m-t-10">
                <p class="p2">{{ progressData.displayName }}</p>
                <div class="flex flex-middle">
                    <span class="p2 col-11"><span class="s2 col-1">{{ progressData.current }}</span>/{{
                        progressData.limit }}</span>
                </div>
            </div>
            <div class="_progressBar m-t-2">
                <div class="_progress"
                     [style.width.%]="getProgressPercentage(progressData.current, progressData.limit)"
                     [class._completed]="progressData.current >= progressData.limit"></div>
            </div>
        </div>
        } @else if (mission.progress.criteria && mission.progress.criteria.length > 0) {
        <!-- Fallback to individual criteria progress bars -->
        <div class="m-t-6">
            @for (criterion of mission.progress.criteria; track criterion.action) {

            <div class="flex flex-justify-between flex-bottom m-t-10">
                <p class="p2">{{ criterion.message | translate }}</p>
                <div class="flex flex-middle">
                    <span class="p2 col-11"><span class="s2 col-1">{{ criterion.current }}</span>/{{
                        criterion.threshold }}</span>
                </div>
            </div>
            <div class="_progressBar m-t-2">
                <div class="_progress"
                     [style.width.%]="getProgressPercentage(criterion.current, criterion.threshold)"
                     [class._completed]="criterion.is_completed"></div>
            </div>
            }
        </div>
        }

        @if(isCompleted) {
        <button *iCms="'doneButtonText' of content"
                [disabled]="true"
                class="button m-t w-12"></button>

        } @else if(hasPushNotificationTag) {
        <button class="button m-t w-12"
                (click)="requestPushNotificationPermission()">
            {{mission.cta_label || content.doItButtonText}}
        </button>

        } @else if(mission.url) {
        <href [link]="getTrimmedMissionUrl(mission.url)">
            <button class="button m-t w-12">
                {{mission.cta_label || content.doItButtonText}}
            </button>
        </href>
        }

        <a *iCms="'backButtonText' of content"
           [routerLink]="['/account/my-missions']"
           class="button-1 m-t w-12"></a>
    </div>
</div>
}
